import { mapColorsToScheme } from '../../../../lib';
export default (function (siteVars) {
    var colorVariant = 500;
    return {
        colors: mapColorsToScheme(siteVars, colorVariant),
        color: siteVars.black,
        descriptionColor: undefined,
    };
});
